import {
  CLEAR_SKILLVENDOR,
  FETCH_SKILLVENDOR_OVERVIEW_SUCCESS,
  FETCH_SKILLVENDOR_PROFILE_SUCCESS,
  CLEAR_SKILLVENDOR_CURRENT_PROFILE,
  FETCH_SKILLVENDOR_PRODUCTIONS_SUCCESS,
  FETCH_SKILLVENDOR_POINTS_SUCCESS,
  FETCH_SKILLVENDOR_DEVICES_SUCCESS,
  FETCH_SKILLVENDOR_HISTORY_PROFILE_STATUSES_SUCCESS
} from '../../../actions/pages/skillvendor-page'

export function skillVendorPage(
  state = {
    overview: null,
    currentProfile: null,
    productions: null,
    points: null,
    devices: null,
    profileStatuses: null
  },
  action
) {
  switch (action.type) {
    case CLEAR_SKILLVENDOR: {
      return Object.assign({}, state, {
        overview: null,
        currentProfile: null,
        productions: null,
        points: null,
        devices: null,
        profileStatuses: null
      })
    }
    case FETCH_SKILLVENDOR_OVERVIEW_SUCCESS: {
      return Object.assign({}, state, {
        overview: action.overview
      })
    }
    case FETCH_SKILLVENDOR_PROFILE_SUCCESS: {
      return Object.assign({}, state, {
        currentProfile: action.currentProfile
      })
    }
    case CLEAR_SKILLVENDOR_CURRENT_PROFILE: {
      return Object.assign({}, state, {
        currentProfile: null
      })
    }
    case FETCH_SKILLVENDOR_PRODUCTIONS_SUCCESS: {
      return Object.assign({}, state, {
        productions: action.productions
      })
    }
    case FETCH_SKILLVENDOR_POINTS_SUCCESS: {
      return Object.assign({}, state, {
        points: action.points
      })
    }
    case FETCH_SKILLVENDOR_DEVICES_SUCCESS: {
      return Object.assign({}, state, {
        devices: action.devices
      })
    }
    case FETCH_SKILLVENDOR_HISTORY_PROFILE_STATUSES_SUCCESS: {
      return Object.assign({}, state, {
        profileStatuses: action.profileStatuses
      })
    }
    default:
      return state
  }
}
